import React, { createContext, useEffect, useState } from "react";

export const TaskContext = createContext();

export const  TaskContextProvider = ( {children} ) => {
  const [reloj, setReloj] = useState({ hora: new Date() });
    function init() {
      setInterval(() => {
      setReloj({ hora: new Date() });
      }, [1000] );
    }
    useEffect(()=>{
      init()
    },[])
  return (
    <TaskContext.Provider value= { reloj }>{children}</TaskContext.Provider>
  );
}